import { FilterDataDto } from '../generated/api-client';
import {
  FilterData,
  DocumentTypeItem,
  OrganizationUnitItem,
  ReferenceItem,
  AreaItem,
  ModuleItem,
} from '../../../features/user/models/filter-data.model';

/**
 * Convierte un FilterDataDto generado por NSwag al tipo de dominio FilterData.
 * Garantiza que todos los arrays existan aunque el backend retorne null/undefined.
 */
export function mapFilterDataDto(dto: FilterDataDto): FilterData {
  return {
    documentTypes: (dto.documentTypes ?? []).map((d): DocumentTypeItem => ({
      id: d.id ?? 0,
      name: d.name ?? '',
    })),
    units: (dto.units ?? []).map((u): OrganizationUnitItem => ({
      id: u.id ?? '',
      name: u.name ?? '',
      levelId: u.levelId ?? 0,
      levelName: u.levelName ?? '',
      parentId: u.parentId ?? undefined,
    })),
    ministries: (dto.ministries ?? []).map((r): ReferenceItem => ({
      id: r.id ?? 0,
      name: r.name ?? '',
    })),
    assignments: (dto.assignments ?? []).map((r): ReferenceItem => ({
      id: r.id ?? 0,
      name: r.name ?? '',
      requiresActiveMinistry: (r as any).requiresActiveMinistry ?? false,
      allowedOrganizationLevelIds: (r as any).allowedOrganizationLevelIds ?? [],
      allowedOrganizationLevelNames: (r as any).allowedOrganizationLevelNames ?? [],
    })),
    appointments: (dto.appointments ?? []).map((r): ReferenceItem => ({
      id: r.id ?? 0,
      name: r.name ?? '',
      allowedOrganizationLevelIds: (r as any).allowedOrganizationLevelIds ?? [],
      allowedOrganizationLevelNames: (r as any).allowedOrganizationLevelNames ?? [],
    })),
    areas: (dto.areas ?? []).map((a): AreaItem => ({
      id: a.id ?? 0,
      name: a.name ?? '',
    })),
    modules: (dto.modules ?? []).map((m): ModuleItem => ({
      id: m.id ?? 0,
      name: m.name ?? '',
    })),
    countries: [],
    nationalities: [],
  };
}
